"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

require("./validatedField.scss");

var ValidatedField = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ValidatedField, _Component);

  var _super = (0, _createSuper2["default"])(ValidatedField);

  function ValidatedField() {
    var _this;

    (0, _classCallCheck2["default"])(this, ValidatedField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderMessage = function () {
      var _this$props = _this.props,
          isValid = _this$props.isValid,
          validationMessage = _this$props.validationMessage;
      return isValid ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: "validated-field-message"
      }, " ", validationMessage, " ");
    };

    return _this;
  }

  (0, _createClass2["default"])(ValidatedField, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          isValid = _this$props2.isValid;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "validated-field ".concat(isValid ? "" : "invalid", " ").concat(className ? className : '')
      }, children, this.renderMessage());
    }
  }]);
  return ValidatedField;
}(_react.Component);

var _default = ValidatedField;
exports["default"] = _default;